import {Injectable} from '@angular/core';
import {FetcherService} from '@core/services/fetcher.service';
import {IUser, LoginForm, SuccessAuth} from '@core/models/user';
import {Observable} from 'rxjs';
import {Api} from '@core/models/api.enum';
import {InitLoaders} from '@core/models/init-loaders';
import {catchError, tap} from 'rxjs/operators';
import {UserService} from '@core/services/user.service';
import {Router} from '@angular/router';

@Injectable({providedIn: 'root'})
export class AuthService extends InitLoaders {


    constructor(private fetcher: FetcherService,
                private router: Router,
                private userService: UserService) {
        super();
    }

    private static successUser(res: SuccessAuth) {
        localStorage.setItem('token', res.token);
        localStorage.setItem('expires_in', res.expires_in);
    }


    login(login: LoginForm): Observable<any> {
        return this.showLoaderUntilCompleted(this.fetcher.post(Api.login, login), 'login')
            .pipe(tap((res: SuccessAuth) => AuthService.successUser(res)));
    }

    updateUser(user: IUser): Observable<IUser> {
        user._method = 'put';
        const formData = this.fetcher.createFormData(user);
        return this.showLoaderUntilCompleted(this.fetcher.post<IUser>(Api.userId, formData, {id: user.id}), 'updateUser')
            .pipe(tap((u: IUser) => this.userService.setUser = u));
    }

    registration(login: LoginForm): Observable<SuccessAuth> {
        return this.showLoaderUntilCompleted(this.fetcher.post<SuccessAuth>(Api.registration, login), 'registration')
            .pipe(tap((res: SuccessAuth) => AuthService.successUser(res)));
    }

    restore(email: string): Observable<any> {
        return this.showLoaderUntilCompleted(this.fetcher.post<any>(Api.restore, {email}), 'restore');
    }

    changePassword(obj): Observable<any> {
        return this.showLoaderUntilCompleted(this.fetcher.post<any>(Api.resetPassword, obj), 'changePassword');
    }

    // @Throttle()
    logout(): void {
        this.fetcher.post(Api.logout)
            .pipe(catchError(err => {
                this.clearUser();
                throw err;
            }))
            .subscribe(() => this.clearUser());

    }

    clearUser() {
        localStorage.clear();
        this.userService.setUser = null;
        this.router.navigate(['/auth/login']);
    }

}
